import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router doesn't touch scroll position on its own. Without this, a
// navigation from /faq back to /#services would just land wherever the new
// page happens to render (usually still scrolled down), and a plain route
// change (say /support to /) would leave the visitor scrolled to the middle
// of the new page instead of starting at the top.
export default function ScrollManager() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Give the new page a frame to render before hunting for the anchor.
      const id = hash.replace('#', '');
      requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
}
